module.exports = __webpack_public_path__ + "static/img/company31.399f85c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/company31.png
// module id = XzvE
// module chunks = 1